import { render } from "./PaginateTitle.vue?vue&type=template&id=49817d5d"
import script from "./PaginateTitle.vue?vue&type=script&lang=js"
export * from "./PaginateTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__